import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import Briefing from '@components/pages/Briefing';

registerWithErrorBoundary({
  Briefing,
});
